module.exports = __webpack_public_path__ + "img/huhn.e7c18754.svg";